module.exports = __webpack_public_path__ + "static/img/ad1.c0d5d7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad1.jpg
// module id = dNmh
// module chunks = 0